import { PreviewCourseSetup } from '@hendrx/core/courses';
import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/courses/preview/$courseDraftId')({
  component: PreviewCourseLayout
});

function PreviewCourseLayout() {
  const params = useParams({ strict: false });

  if (!params.courseDraftId) {
    return null;
  }

  return (
    <PreviewCourseSetup
      courseDraftId={params.courseDraftId}
      categoryId={params.categoryId}
      activityId={params.activityId}
    >
      <Outlet />
    </PreviewCourseSetup>
  );
}
